<template>
  <!-- need list headers  -->
  <ul>
    <thead>
      <tr>
        <td>Claims {{ modelData }}</td>
      </tr>
    </thead>
    <!-- <tbody>
      <tr v-for="(trial, index) in pgPhysicianData" :key="index">
        <td>{{ trial.FirstName }}</td>
        <td>{{ trial.LastName }}</td>
        <td>{{ trial.Specialty }}</td>
      </tr>
    </tbody> -->
  </ul>
</template>

<script>
export default {
  props: ['modelData', 'npi', 'runID', 'cohortId'],
  data() {
    return {};
  },
  methods: {
    getData() {
      // set the modeldata to the claims stuff here
      // axios.get(`/HCPProfiles/${this.$route.params.cohortId}/${this.$route.params.runId}/${this.$route.params.npi}`)
      //   .then(response => {
      //     this.modelData = JSON.parse(response.data);
      //     debugger;
      //   })
    },
  },
  created() {
    this.getData()
  },
  mounted() {
  },
}
</script>
